import { render, staticRenderFns } from "./companyAccount.vue?vue&type=template&id=a3c66fae&scoped=true"
import script from "./companyAccount.vue?vue&type=script&lang=js"
export * from "./companyAccount.vue?vue&type=script&lang=js"
import style0 from "./companyAccount.vue?vue&type=style&index=0&id=a3c66fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c66fae",
  null
  
)

export default component.exports